import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgHotelQuantity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <mask id="hotel-quantity_svg__b" fill="#fff">
        <use href="#hotel-quantity_svg__a" />
      </mask>
    </defs>
    <path
      className="hotel-quantity_svg__stroke"
      id="hotel-quantity_svg__a"
      d="M1 3.89V4a.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5v6.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V11a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5v-.11a.61.61 0 0 0-.354-.554L7.919.693a1 1 0 0 0-.838 0L1.354 3.336A.61.61 0 0 0 1 3.89Z"
      stroke="#17181A"
    />
    <g
      className="hotel-quantity_svg__fill"
      fill="#17181A"
      mask="url(#hotel-quantity_svg__b)"
    >
      <rect
        className="hotel-quantity_svg__rectY"
        x="0%"
        y="100%"
        rx={0}
        ry={0}
        width="100%"
        height="100%"
      />
    </g>
  </svg>
);
const Memo = memo(SvgHotelQuantity);
export default Memo;
